import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Then, head to `}<strong parentName="p">{`Slack`}</strong>{` and add PostHog to `}<strong parentName="p">{`specific Slack channels`}</strong>{`. To do this:`}</p>
    <ol>
      <li parentName="ol">{`In the Slack `}<a parentName="li" {...{
          "href": "https://slack.com/help/articles/360059928654-How-to-use-Slack--your-quick-start-guide#channels"
        }}>{`channel header`}</a>{`, click the top right menu and click `}<strong parentName="li">{`Open channel details`}</strong></li>
      <li parentName="ol">{`Navigate to the `}<strong parentName="li">{`Integrations`}</strong>{` tab`}</li>
      <li parentName="ol">{`Click the `}<strong parentName="li">{`Add an app`}</strong>{` button`}</li>
      <li parentName="ol">{`Under `}<strong parentName="li">{`In your workspace`}</strong>{`, click `}<strong parentName="li">{`PostHog`}</strong></li>
    </ol>
    <p>{`You can also try tagging the `}<inlineCode parentName="p">{`@PostHog`}</inlineCode>{` bot in the channel to add it to the channel.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      